import { CSSProperties } from 'react';
import styled from 'styled-components';

type DayProps = {
  isSelected?: boolean;
  day: string;
  style?: CSSProperties;
} & React.HTMLAttributes<HTMLDivElement>;

export default function Day({
  day,
  isSelected = false,
  style,
  ...props
}: DayProps) {
  return (
    <Wrapper style={style} isSelected={isSelected} {...props}>
      {day}
    </Wrapper>
  );
}

const Wrapper = styled.div<{
  isSelected: boolean;
}>`
  border: ${({ isSelected, theme }) =>
    isSelected
      ? `2px solid ${theme.palette.brand400}`
      : `1px solid ${theme.palette.gray700}`};
  background-color: ${({ theme }) => theme.palette.gray800};
  ${({ isSelected }) => isSelected && `font-weight: 600;`};
  border-radius: 8px;
  color: ${({ theme, isSelected }) =>
    isSelected ? theme.palette.brand300 : theme.palette.gray100};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
